<template>
  <div class="hs-cell-small-title" :type="fixedLanguage ? fixedLanguage : language">
    <div class="details" :class="[alignItems]" :style="{'border-bottom-width': showSeparator ? '1px' : '0px'}">
      <div class="left" :style="{width: showLogo ? 'calc(100% - 30px)' : '100%', position: tips.tips && tips.show ? 'relative': 'static'}">
        <div class="header">
          <div>
            <div class="header-title">
              <span>{{title}}</span>
              <span v-if="subtitle" class="subtitle">{{subtitle}}</span>
            </div>
            <span class="required" v-if="required">*</span></div>
          <div class="logo" :style="{backgroundImage: `url(${require('@/assets/image/plane-ticket/details/zhushi.png')})`}" v-if="warning" @click.stop="_clickHeader"></div>
        </div>
        <slot>
          <p class="normal normal-placeholder" v-if="type === 'normal-placeholder'">
            <span v-if="!currentValue">{{placeholder}}</span>
            <template v-else>{{currentValue}}</template>
          </p>
          <p class="normal" v-if="type === 'normal'">{{currentValue}}</p>
          <p class="normal" v-else-if="type === 'html'" v-html="$getValReplaceWrap(currentValue)"></p>
          <p class="bold" v-else-if="type === 'bold'">{{currentValue}}</p>
          <input class="input" @focus="_focus" @blur="_blur" v-model.trim="currentValue" :maxlength='maxlength' :placeholder="placeholder" v-else-if="type === 'input'"/>
          <input class="input disabled" v-model.trim="currentValue" maxlength='50' :placeholder="placeholder" v-else-if="type === 'disabled-input'"/>
        </slot>
        <slot name="des"></slot>
        <span v-if="tips && tips.tips && tips.show" class="tips">{{tips.tips}}</span>
      </div>
      <div
        v-if="showLogo" @click.stop="$emit('logoClick')"
        class="logo" :class="{'icon-clear': hasClear && currentValue}" :style="{backgroundImage: `url(${require('@/assets/image/base/cell/' + cmpLogoName)})`}"></div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'normal'
    },
    placeholder: {
      type: String,
      default: ''
    },
    logoName: {
      type: String,
      default: 'right_arrow_gray.png'
    },
    showLogo: {
      type: Boolean,
      default: true
    },
    hasClear: { // 是否有清空按钮
      type: Boolean,
      default: false
    },
    showSeparator: {
      type: Boolean,
      default: true
    },
    warning: {
      type: Boolean,
      default: false
    },
    fixedLanguage: {
      type: String,
      default: ''
    },
    tips: { // 提示信息
      type: Object,
      default: () => {
        return {
          tips: '',
          show: false
        }
      }
    },
    alignItems: { // 对其方式 默认空 baseline
      type: String,
      default: ''
    },
    required: { // 是否显示必填*
      type: Boolean,
      default: false
    },
    maxlength: { // 是否显示必填*
      type: Number,
      default: 50
    }
  },
  computed: {
    currentValue: {
      get: function() {
        return this.value
      },
      set: function(val) {
        return this.$emit('input', val)
      }
    },
    cmpLogoName() { // 计算后的logoName
      let logoName = this.logoName
      if (this.hasClear && this.currentValue) {
        logoName = 'close_gray.png'
      }
      return logoName
    }
  },
  methods: {
    _clickHeader() {
      this.$emit('header')
    },
    _focus(val) {
      this.$emit('focus', val)
    },
    _blur(val) {
      this.$emit('blur', val)
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/mixin.styl'
.hs-cell-small-title
  @extend .flex-row
  @extend .flex-start
  width 100%
  padding 0 15px
  >.details
    @extend .flex-row
    @extend .flex-between
    width 100%
    min-height 44px
    padding 10px 0
    border-bottom 1px solid $color_gray_layer
    &.baseline
      align-items center
      padding 10px 0
      >.left
        align-items baseline
    >.left
      >.header
        @extend .flex-row
        @extend .flex-start
        width 100%
        font-size 0.8rem
        color $color_font_black
        margin-bottom 8px
        line-height 1.2em
        padding-right 5px
        word-break break-all
        >.logo
          width 14px
          height 14px
          background-size 100% 100%
          margin-left 3px
          flex-shrink 0
        .header-title
          display flex
          flex-direction column
          >.subtitle
            font-size 12px
            line-height 1em
        .required
          color $color_theme
      >.normal
      >.bold
      >.input
        width 100%
        min-height 1.2em
        font-size 1rem
        line-height 1.2em
        padding 0
      >.bold
        font-weight bold
      >.normal-placeholder
        span
          color $color_gray_placeholder
    >.logo
      width 20px
      height 20px
      background-size 100% 100%
      flex-shrink 0
    >.icon-clear
      background-position center
      background-size 12px 12px
      background-repeat no-repeat
  &:last-child
    >.details
      border-bottom 0px !important
  p
    word-break break-all
  &[styleType='big-line']
    >.details
      min-height 54px
      >.left
        >.header p
          font-size 15px
        >.normal,
        >.bold,
        >.input
          font-size 15px
.hs-cell-small-title[type="CN"],.hs-cell-small-title[type="TC"]
  >.details
    padding 5px 0
    &.baseline
      align-items flex-start
      padding 10px 0
    >.left
      @extend .flex-row
      @extend .flex-start
      >.header
        width 105px
        font-size 1rem
        margin-bottom 0px
        flex-shrink 0
        >.logo
          width 18px
          height 18px
      >.normal
      >.bold
      >.input
        @extend .flex-row
        @extend .flex-start
        width calc(100% - 105px)
        min-height 33px
      >.normal-placeholder
        span
          color $color_gray_placeholder
.tips
  ellipsis(1)
  position absolute
  bottom -4px
  left 105px
  font-size .8rem
  transform scale(.8)
  transform-origin left
  line-height 1.2em
  color $color_theme
</style>
